<template>
  <div>
    <div style="display:block; position:absolute;top:-9999px">
      <div class="previewContainer2"
           style="border:none"
           ref="outputImg"
           :class="{
             'backgroundCoach':printWithBackground && backgroundStyle==='coach',
             'backgroundOfficiel':printWithBackground && backgroundStyle==='officiel',
             'backgroundEtranger':printWithBackground && backgroundStyle==='etranger',
           }"
      >
        <div class="provisoire" v-if="provisoire">Provisoire</div>
        <div class="provisoire_div pull-right" v-if="provisoire">Carte coach provisoire valable jusqu'au
          {{date_fin_provisoire}}
        </div>
        <img
          class="photo"
          v-if="photo_base64"
          width="385"
          height="500"
          :src="photo_base64"/>

        <div class="caption">
          <div class="captionContainer">
            <div class="firstLine">{{ firstLine }}</div>
            <div class="secondLine">{{ secondLine }}</div>
            <div class="thirdLine">{{ thirdLine }}</div>
            <div class="hrVertical"
                 :class="{
                           'backgroundCoach':backgroundStyle==='coach',
                           'backgroundOfficiel':backgroundStyle==='officiel',
                           'backgroundEtranger':backgroundStyle==='etranger'
                          }"
            ></div>
          </div>
        </div>

      </div>
    </div>

    <div class="content-wrapper">
      <!-- Content Header (Page header) -->
      <section class="content-header">
        <h1>
          Génération de carte pré-imprimée (coach, VIP, ABFT officiel)
          <small></small>
        </h1>
        <ol class="breadcrumb">
          <li>
            <router-link :to="{ name: 'Dashboard'}">
              <i class="fa fa-dashboard"></i>
              Accueil
            </router-link>
          </li>
          <li><a href="#">Outils</a></li>
          <li class="active">Génération carte pré-imprimée</li>
        </ol>
      </section>

      <section class="content">
        <div class="row">
          <div class="col-xs-4 col-sm-4 col-md-4 col-lg-4">

            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingCarte">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Aide à la génération</h3>
              </div>

              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Recherche de membre</label>
                      <v-select v-model="memberSelected"
                                id="searchmember"
                                label="fullName"
                                :filterable="false"
                                :taggable="false"
                                :debounce="250"
                                :on-search="SearchMembersResponse"
                                :options="ArrayMembersSearch">
                                            <span slot="selected-option" slot-scope="props">
                                                <router-link
                                                  :to="{ name: 'Member', params: { member_id: props.selectedOption.id }}">
                                                {{ props.selectedOption.fullName }}  - {{
                                                    props.selectedOption.club.club
                                                  }}
                                                </router-link>
                                            </span>
                        <template slot="option" slot-scope="props">
                                        <span :class="props.item.licencie ? 'text-green' : 'text-red'">
                                            {{ props.item.fullName }} - {{ props.item.club.club }}
                                        </span>
                        </template>
                      </v-select>
                    </div>
                    <hr>
                    <label>Recherche de club</label>
                    <searchclub ref="searchclub"
                                :limit="5"
                                :min-chars="2"
                    >
                    </searchclub>
                  </div>
                </div>
              </div>
            </div>


            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingCarte">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Informations</h3>
              </div>

              <div class="box-body">
                <div class="row">
                  <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                    <div class="form-group">
                      <label>Photo</label><br/>
                      <a class="btn btn-primary btn-flat margin "
                         @click="show_upload_photo=!show_upload_photo">
                        Importer photo</a>
                      <my-upload field="img"
                                 @crop-success="cropSuccess"
                                 @crop-upload-success="cropUploadSuccess"
                                 @crop-upload-fail="cropUploadFail"
                                 v-model="show_upload_photo"
                                 :width="385"
                                 :height="500"
                                 langType="fr"
                                 :noCircle="true"
                                 img-format="jpg">
                      </my-upload>
                    </div>
                    <div class="form-group">
                      <label for="firstLine">Première ligne</label>
                      <input type="email" class="form-control" id="firstLine"
                             placeholder="Nom" v-model="firstLine">
                    </div>
                    <div class="form-group">
                      <label for="secondLine">Deuxième ligne</label>
                      <input type="email" class="form-control" id="secondLine"
                             placeholder="Prenom" v-model="secondLine">
                    </div>
                    <div class="form-group">
                      <label for="thirdLine">Club</label>
                      <input type="email" class="form-control" id="thirdLine"
                             placeholder="Nom du club" v-model="thirdLine">
                    </div>
                  </div>
                </div>
              </div>

            </div>
          </div>
          <div class="col-xs-8 col-sm-8 col-md-8 col-lg-8">
            <div class="box box-primary">
              <div class="overlay"
                   v-if="generatingCarte">
                <i class="fa fa-refresh fa-spin"></i>
              </div>
              <div class="box-header with-border">
                <h3 class="box-title">Aperçu</h3>
              </div>

              <div class="box-body boxSize">
                <div class="previewZoomOut">
                  <div :class="{
                    'previewContainer':true,
                     'backgroundCoach':printWithBackground && backgroundStyle==='coach',
                     'backgroundOfficiel':printWithBackground && backgroundStyle==='officiel',
                     'backgroundEtranger':printWithBackground && backgroundStyle==='etranger',
                   }"
                  >
                    <div class="provisoire" v-if="provisoire">Provisoire</div>
                    <div class="provisoire_div pull-right" v-if="provisoire">Carte coach provisoire valable jusqu'au
                      {{date_fin_provisoire}}
                    </div>

                    <img
                      class="photo"
                      v-if="photo_base64"
                      width="385"
                      height="500"
                      :src="photo_base64"/>

                    <div class="caption">
                      <div class="captionContainer">
                        <div class="firstLine">{{ firstLine }}</div>
                        <div class="secondLine">{{ secondLine }}</div>
                        <div class="thirdLine">{{ thirdLine }}</div>
                        <div class="hrVertical"
                             :class="{
                           'backgroundCoach':backgroundStyle==='coach',
                           'backgroundOfficiel':backgroundStyle==='officiel',
                           'backgroundEtranger':backgroundStyle==='etranger'
                          }"
                        ></div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-footer">
                <div class="col-md-4">
                  <div class=" pull-left">
                    <div class="form-group">
                      <label>Type de carte:</label>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios1" value="coach" checked="">
                          Carte coach
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios2" value="officiel">
                          Carte officiel
                        </label>
                      </div>
                      <div class="radio">
                        <label>
                          <input type="radio" v-model="backgroundStyle" name="backgroundStyle"
                                 id="optionsRadios3" value="etranger">
                          Carte coach étranger
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="provisoire" value="">
                        Carte provisoire
                      </label>
                    </div>
                  </div>

                  <div class="form-group"
                       :class="{'has-error': errors.has('date_fin_provisoire') }"
                       v-if="provisoire">
                    <label>Date de fin</label>
                    <div class="input-group date">
                      <div class="input-group-addon">
                        <i class="fa fa-calendar"></i>
                      </div>
                      <masked-input type="text"
                                    v-model="date_fin_provisoire"
                                    v-validate="'date_format:DD/MM/YYYY'"
                                    :mask="[/\d/, /\d/, '/', /\d/, /\d/, '/', /\d/, /\d/, /\d/, /\d/]"
                                    :guide="true"
                                    :keepCharPositions="true"
                                    :showMask="true"
                                    name="date_fin_provisoire"
                                    class="form-control pull-right datepicker"
                                    id="datepicker2"
                      >
                      </masked-input>
                    </div>
                    <span v-show="errors.has('date_fin_provisoire')"
                          class="help-block">Date incorrecte</span>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="pull-right">
                    <div class="checkbox">
                      <label>
                        <input type="checkbox" v-model="printWithBackground" value="">
                        Imprimer avec le fond
                      </label>
                    </div>
                    <button
                      @click="generateCarte()"
                      :disabled="generatingCarte"
                      type="button" class="btn btn-primary pull-right" style="margin-right: 5px;">
                      <i class="fa fa-download"></i> Télécharger la carte
                    </button>

                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

      </section>
      <!-- OUTPUT -->
      <img :src="output">
    </div>

  </div>
</template>

<style scoped lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Roboto:ital,wght@0,100;0,300;0,400;0,500;0,700;0,900;1,100;1,300;1,400;1,500;1,700;1,900&display=swap');


.previewContainer {
  height: 600px;
  width: 426px;
  display: block;
  margin: auto;
  border: 1px solid #000;
  position: relative;
  background: url('../../assets/img/carte_coach_vierge.jpg') no-repeat;
  background-size: contain;

  &.backgroundCoach {
    background: url('../../assets/img/carte_coach_vierge.jpg') no-repeat;
    background-size: contain;
  }

  &.backgroundOfficiel {
    background: url('../../assets/img/carte_officiel_vierge.jpg') no-repeat;
    background-size: contain;
  }

  &.backgroundEtranger {
    background: url('../../assets/img/carte_officiel_etranger.jpg') no-repeat;
    background-size: contain;
  }

  .provisoire {
    color: #e3023e;
    text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
    font-size: calc(200px * 0.35);
    font-weight: bold;
    position: absolute;
    z-index: 99;
    transform: rotate(-90deg);
    top: calc(515px * 0.35);
    left: calc(-400px * 0.35);;
  }

  .provisoire_div {
    color: #e3023e;
    font-size: calc(48px * 0.35);
    line-height: calc(48px * 0.35);
    transform: rotate(-90deg);
    top: calc(600px * 0.35);
    left: calc(-450px * 0.35);;
    position: absolute;
  }

  .photo {
    position: absolute;
    right: calc(125px * 0.35);
    top: calc(100px * 0.35);
    width: 135px;
    height: 175px;
  }

  .caption {
    position: absolute;
    right: calc(95px * 0.35);
    top: calc(660px * 0.35);
    text-align: right;
    line-height: calc(100px * 0.35);


    .captionContainer {
      position: relative;
      padding-right: calc(20px * 0.35);
    }

    .hrVertical {
      position: absolute;
      right: 0px;
      top: 0px;
      height: 100%;
      background-color: #0d76bd;
      width: calc(10px * 0.35);

      &.backgroundCoach {
        background-color: #0d76bd;
      }

      &.backgroundOfficiel {
        background-color: #000;
      }

      &.backgroundEtranger {
        background-color: #e3023e;
      }
    }

    .firstLine {
      font-family: 'Roboto', sans-serif;
      font-size: calc(120px * 0.35);
      font-weight: bold;
    }

    .secondLine {
      font-family: 'Roboto', sans-serif;
      font-size: calc(120px * 0.35);
      font-weight: bold;
    }

    .thirdLine {
      font-family: 'Roboto', sans-serif;
      font-size: calc(64px * 0.35);
      font-style: italic;
      margin-top: calc(10px * 0.35);
      width: (426px*0.75);
      overflow-wrap: break-word;
    }

  }
}

.previewContainer2 {
  height: 1748px;
  width: 1240px;
  border: 1px solid #000;
  position: relative;
  background: #FFF;
  background-size: contain;

  &.backgroundCoach {
    background: url('../../assets/img/carte_coach_vierge.jpg') no-repeat;
  }

  &.backgroundOfficiel {
    background: url('../../assets/img/carte_officiel_vierge.jpg') no-repeat;
  }

  &.backgroundEtranger {
    background: url('../../assets/img/carte_officiel_etranger.jpg') no-repeat;
  }

  .provisoire {
    color: #e3023e;
    text-transform: uppercase;
    font-family: 'Roboto', sans-serif;
    font-size: calc(200px );
    font-weight: bold;
    position: absolute;
    z-index: 99;
    transform: rotate(-90deg);
    top: calc(515px );
    left: calc(-400px );;
  }

  .provisoire_div {
    color: #e3023e;
    font-size: calc(48px );
    line-height: calc(48px );
    transform: rotate(-90deg);
    top: calc(600px );
    left: calc(-450px);;
    position: absolute;
  }

  .photo {
    position: absolute;
    right: 125px;
    top: 100px;
  }

  .caption {
    position: absolute;
    right: 95px;
    top: 660px;
    text-align: right;
    line-height: 100px;

    .captionContainer {
      position: relative;
      padding-right: 20px;
    }

    .hrVertical {
      position: absolute;
      right: 0px;
      top: 0px;
      height: 100%;
      width: 10px;

      &.backgroundCoach {
        background-color: #0d76bd;
      }

      &.backgroundOfficiel {
        background-color: #000;
      }

      &.backgroundEtranger {
        background-color: #e3023e;
      }
    }

    .firstLine {
      font-family: 'Roboto', sans-serif;
      font-size: 120px;
      font-weight: bold;
    }

    .secondLine {
      font-family: 'Roboto', sans-serif;
      font-size: 120px;
      font-weight: bold;
    }

    .thirdLine {
      font-family: 'Roboto', sans-serif;
      font-size: 64px;
      font-style: italic;
      margin-top: 10px;
      width: (1240px*0.75);
      overflow-wrap: break-word;
    }
  }
}


</style>

<script type="text/babel">
import {mapGetters, mapActions} from 'vuex'
import cropUpload from '../Communs/ImgCropUpload'
import vSelect from "../Communs/vSelect";

var moment = require('moment')
var FileSaver = require('file-saver');
var $ = require('jquery');
var variables = require('../../assets/js/variables')
var _ = require('underscore')

require('../../../node_modules/bootstrap-datepicker/js/bootstrap-datepicker');
require('../../../node_modules/bootstrap-datepicker/js/locales/bootstrap-datepicker.fr');

export default {
  data() {
    return {
      firstLine: "",
      secondLine: "",
      thirdLine: "",
      photo_base64: null,
      loading: false,
      resize: false,
      redraw: "",
      show_upload_photo: false,
      generatingCarte: false,
      ArrayMembersSearch: [],
      memberSelected: null,
      output: null,
      backgroundStyle: "coach",
      printWithBackground: false,
      provisoire: false,
      date_fin_provisoire: null
    }
  },
  methods: {
    ...mapActions({
      majClubSelected: "majClubSelected",
    }),
    dataURItoBlob: function (dataURI) {
      // convert base64 to raw binary data held in a string
      // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
      let byteString = atob(dataURI.split(',')[1]);

      // separate out the mime component
      let mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0]

      // write the bytes of the string to an ArrayBuffer
      let ab = new ArrayBuffer(byteString.length);

      // create a view into the buffer
      let ia = new Uint8Array(ab);

      // set the bytes of the buffer to the correct values
      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      // write the ArrayBuffer to a blob, and you're done
      let blob = new Blob([ab], {type: mimeString});
      return blob;

    },
    async generateCarte() {
      this.generatingCarte = true
      const el = this.$refs.outputImg;
      // add option type to get the image version
      // if not provided the promise will return
      // the canvas.
      const options = {
        type: 'dataURL',
        // width: 1240,
        // height: 1748,
        // scale: 1
      }

      this.output = await this.$html2canvas(el, options).then((canvas) => {
        console.log(canvas);
        FileSaver.saveAs(this.dataURItoBlob(canvas), "CarteCoach" + _.random(0, 10000000) + ".png");
        // saveAs(canvas.toDataURL(), 'file-name.png');
      });
      this.generatingCarte = false
    },
    SearchMembersResponse: function (search, loading) {
      if (search.length <= 2)
        return;
      let these = this;
      loading(true)
      this.$http.post(this.getRoute("memberSearch"), {q: search}, {
        before(request) {
          if (these.previousRequest)
            these.previousRequest.abort();
          these.previousRequest = request;
        }
      }).then(resp => {
        loading(false)
        let idsAlreadyExists = "";
        this.ArrayMembersSearch = resp.data;
        this.getCompetition.participations.forEach((item) => {
          this.ArrayMembersSearch = _.reject(this.ArrayMembersSearch, function (item2) {
            return item.membre.id == item2.id
          });
        })
        this.ArrayMembersSearch = _.where(this.ArrayMembersSearch, {licencie: true}).concat(_.where(this.ArrayMembersSearch, {licencie: false}))
      })
    },

    cropSuccess(imgDataUrl, field) {
      this.photo_base64 = imgDataUrl;
    },
    cropUploadSuccess(jsonData, field) {
    },
    cropUploadFail(status, field) {
    },
    titleCase(str) {
      var splitStr = str.toLowerCase().split(' ');
      for (var i = 0; i < splitStr.length; i++) {
        // You do not need to check if i is larger than splitStr length, as your for does that for you
        // Assign it back to the array
        splitStr[i] = splitStr[i].charAt(0).toUpperCase() + splitStr[i].substring(1);
      }
      // Directly return the joined string
      return splitStr.join(' ');
    }

  },
  computed: {
    ...mapGetters({
      getClubSelected: 'getClubSelected',
      getRoute: 'getRoute'
    }),
    editor() {
    }
  },
  components: {
    'my-upload': cropUpload,
    vSelect,
  },
  watch: {
    thirdLine: function (value) {
      this.thirdLine = this.titleCase(value.toLowerCase())
    },
    getClubSelected: function (value) {
      if (value && value != "") {
        this.thirdLine = this.getClubSelected.club
        this.majClubSelected(null)
      }
    },
    memberSelected: function (value) {
      if (value && value != "") {
        this.firstLine = value.prenom
        this.secondLine = value.nom
        this.thirdLine = value.club.club
        this.memberSelected = null
      }
    }
  },
  mounted() {

  }
}
</script>



// WEBPACK FOOTER //
// src/components/Outils/GenerationCarteCoach.vue